<div class="progress-spinner-div" *ngIf="flag">
    <mat-progress-spinner color="primary" mode="indeterminate" class="custom-spinner"></mat-progress-spinner>
    <p class="custom-spinner-text">{{label}}</p>
</div>